<template>
  <div v-on:click="openClass(classInfo.id)">
    <el-card class="app-open-curriculum-card">
      <img alt="pic" :src="classInfo.coverPhoto" style="height: 170px;width: 260px;display: block"/>
      <p class="app-open-curriculum-card-title">{{ classInfo.name }}</p>
      <div class="app-open-curriculum-card-other">
        <p style="position: absolute;top: -15px;left: 10px;font-size: 10px">
          {{ new Date(classInfo.createTime).toLocaleDateString().replace(/\//g, '-') }}</p>
        <i class="el-icon-star-off"></i>
        <span> {{ classInfo.collectionTimes }}</span>
        <i class="el-icon-view"></i>
        <span>{{ classInfo.viewTimes }} </span>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "ClassCard",
  props: {
    classInfo: Object,
    openType: String,
  },
  methods: {
    openClass(id) {
      if (this.openType === undefined || this.openType.length === 0) {
        this.$router.push("/article/" + id)
      } else {
        window.open(this.$router.resolve("/article/" + id).href)
      }
    }
  }
}
</script>

<style scoped>

.app-open-curriculum-card {
  margin-bottom: 15px;
  margin-left: 15px;
  height: 285px;
  width: 260px;
  cursor: pointer;
  text-align: left
}

.app-open-curriculum-card-title {
  margin: 5px 10px 0 10px;
  height: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.app-open-curriculum-card-other {
  position: relative;
  top: 25px;
  left: 0;
  height: 35px;
  width: 220px;
  text-align: left;
}

.app-open-curriculum-card-other i {
  font-size: 20px;
  margin-left: 10px;
  margin-top: 15px;
}

.app-open-curriculum-card-other span {
  position: relative;
  left: 3px;
}

</style>